"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabSizeEnum = void 0;
var TabSizeEnum;
(function (TabSizeEnum) {
    TabSizeEnum["Minimized"] = "Minimized";
    TabSizeEnum["Mini"] = "Mini";
    TabSizeEnum["Maximized"] = "Maximized";
})(TabSizeEnum = exports.TabSizeEnum || (exports.TabSizeEnum = {}));
